import { useEffect } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default function GlobalLoadingIndicator() {
  const isFetching = useIsFetching({
    predicate: (query) => {
      const queryKey = query.queryKey;

      const isUploadStatusQuery = queryKey.some((key) => {
        if (typeof key === 'string') {
          return (
            key.includes('upload-status') ||
            key.includes('configuration-upload-status')
          );
        }
        return false;
      });

      return !isUploadStatusQuery;
    },
  });

  const isMutating = useIsMutating();

  useEffect(() => {
    if (isFetching || isMutating) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [isFetching, isMutating]);

  return null;
}
